import React from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import Breadcrumb from '@ui-library/core/Breadcrumb';
import Street from '../blocks/seopage/Street';

const Container = styled.div`
  max-width: 1024px;
  margin: auto;
  padding-left: 24px;
  padding-right: 24px;

  @media screen and (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #2b2b2b;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 26px;
  }
`;

const BreadcrumbContainer = styled(Breadcrumb)`
  margin: 20px 0 40px -40px;
`;

const SeoPage = ({ config }) => {
  const seoPageData = config ? config.seoPageObject : [];

  const breadcrumbValues = seoPageData.saleBreadCrumb.map((value, index) => ({
    label: value.label,
    link: value.url,
    position: index,
  }));

  return (
    <>
      <Container>
        <BreadcrumbContainer elements={breadcrumbValues} />
      </Container>
      <Helmet>
        <title>{seoPageData.titleSale}</title>
      </Helmet>
      <Container>
        <Title>{seoPageData.h1Sale}</Title>
        <Street data={seoPageData} />
      </Container>
    </>
  );
};

export default SeoPage;
